/*
 * @Description: 带头图大于4张卡片的样式
 * @Author: ywj
 * @Date: 2025-02-07 11:04:44
 * @LastEditTime: 2025-04-27 11:04:43
 * @LastEditors: ywj@originqc.com
 */
import React, { useState } from 'react'
import CustomTitle from '@/components/custom-title';
import GoMore from '@/components/more';
import MiniTab from '@/components/tab';
import Card from '@/components/card'
import leftBg from '../imgs/leftBg.png';
import { goodsData } from '../../config'
import ServiceIds from '@/components/service-ids';
import './index.scss';

interface IGoods {
  // title: string,
  isTab: string,//more显示更多，tab,tab切换标签1，标签2
  goodsData: any,
  data: any,

}

const showType = ['coming', 'halfMore', 'more']
const Goods: React.FC<IGoods> = (props) => {
  const { isTab, goodsData, data } = props;

  const [tabId, setTabId] = useState<number>(props.goodsData![0]?.id);
 

  return (
    <>
      <div className="goods-top">
        <CustomTitle title={data?.name} />{isTab === 'more' ? <GoMore data={ data} /> : <MiniTab data={goodsData} setTabId={setTabId} />}
      </div>
      <div className="goods-box">
        <div className="goods-left">
          <p className='goods-title'>{data?.mainProductName}</p>
          <p className='goods-subtitle'>
            <ServiceIds serviceIds={data?.serviceIds} />
          </p>
          <img src={data?.pic} alt="bg" />
        </div>
        <div className="goods-right">
          {goodsData?.find((cat: any) => cat.id === tabId)?.products?.map((item: any) => {
            return (
              <Card
                {...item}
                goodsData={goodsData?.find((cat: any) => cat.id === tabId)?.products}
                is_list="home"
                tabId={tabId}
                data={data}
              />
            )

          })}
        </div>

      </div>
    </>
  )
}

export default Goods;